import { HomepageHeroProps } from 'libs/contentful/props';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import RichTextList from 'components/shared/RichTextList/RichTextList';
import { CheckmarkHeavy } from '@1debit/icons';

interface HomepageHeroListProps extends Pick<HomepageHeroProps, 'sys' | 'copy'> {
  listDisplay?: 'inline' | 'block';
}

const HomepageHeroList = ({ sys, copy, listDisplay }: HomepageHeroListProps) => {
  return (
    <div
      className="font-sans font-medium mx-auto max-sm:w-full text-(--hero-accent-text)"
      {...liveUpdateAttrs(sys?.id, 'copy')}>
      {copy && (
        <RichTextList
          item={copy}
          customIcon={
            <CheckmarkHeavy
              color="var(--color-fern)"
              size={14}
              className="mt-1 -mr-1 [&_path]:!stroke-fern in-cw-action-primary:[&_path]:!stroke-white" // Fix for ChimeKit icon not changing the stroke based on the color prop
            />
          }
          listDisplay={listDisplay}
        />
      )}
    </div>
  );
};

export default HomepageHeroList;
